<template>
    <div class="main-search-city">
        <div class="title">Знайдемо найближчу аптеку</div>
        <div class="search-sity-form">
            <form action="" class="form">
                <div class="input-container">
                    <input v-model="query" type="text" class="input input-search important" placeholder="Введіть назву Вашого міста">
                </div>
                <button type="submit" class="submit"><span class="ic icon-ic_search"></span></button>
            </form>
        </div>
        <div class="search-sity-links">
            <a v-for="city in filteredCities" @click="selectCity(city)" href="#" class="sity-link">{{ city.name }}</a>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    computed: {
        query: {
            get() {
                return this.$store.state.location.searchCityQuery;
            },
            set(value) {
                this.$store.commit('location/setSearchCityQuery', value)
            },
        },
        filteredCities() {
            return this.$store.getters['location/filteredCities'];
        },
    },
    created() {
    },
    mounted() {
    },
    methods: {
        selectCity(city){
            let vm = this
            this.$inertia.visit(vm.route('frontend.set-city', city), {
                method: 'get',
                onSuccess: page => {
                    this.$inertia.get(vm.route('frontend.stores.index'))
                },
            })
        }
    }
}
</script>
